/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';

/**
 *
 * @class HelpAboutAction
 *
 * @brief show the about dialog
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class HelpAboutAction extends Action {

  constructor(options: any = null) {

    super({
      key:   'help.about',
      type:  ActionType.Help_About,
      label: 'About',
      icon:  '<i class="fab fa-product-hunt"></i>',
      tip:   'View product description'
    });

  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[HelpAboutAction] executing...');

    return true;
  }
}
